export const shipmentInfoTemplate = {
  rows: [
    {
      cols: [
        { title: 'To Trucking Co', id: 'toTruckingCo', span: 0.5 },
        { title: 'Bill To', id: 'billTo', span: 0.5 }
      ]
    },
    {
      cols: [
        { title: 'Delivery To', id: 'deliveryTo', span: 0.5 },
        {
          span: 0.5,
          rows: [
            {
              cols: [
                {
                  title: 'Pick-Up Ref No',
                  id: 'pickUpRefNo',
                  span: 0.5
                },
                {
                  title: 'Delivery Ref No',
                  id: 'deliveryRefNo',
                  span: 0.5
                }
              ]
            },
            {
              cols: [
                {
                  title: 'Pick-Up Date/Time',
                  id: 'pickUpDateTime:',
                  span: 0.5
                },
                {
                  title: 'Delivery Date/Time',
                  id: 'deliveryDateTime',
                  span: 0.5
                }
              ]
            },
            {
              cols: [
                {
                  title: 'Billing Reference No',
                  id: 'billingReferenceNo:',
                  span: 0.5
                },
                {
                  title: 'Carrier',
                  id: 'carrier',
                  span: 0.5
                }
              ]
            }
          ]
        }
      ]
    },
    {
      cols: [
        { title: 'Pick-Up At', id: 'pickUpAddress', span: 0.5 },
        {
          span: 0.5,
          rows: [
            {
              cols: [
                { title: 'Master B/L No', id: 'mbl', span: 0.5 },
                {
                  title: 'Vessel/Voyage No',
                  id: 'vesselVoyageNo',
                  span: 0.5
                }
              ]
            },
            {
              cols: [
                { title: 'House B/L No', id: 'houseBlNo', span: 0.5 },
                {
                  title: 'AMS House BL No',
                  id: 'amsHouseBlNo',
                  span: 0.5
                }
              ]
            }
          ]
        }
      ]
    },
    {
      cols: [
        { title: 'CNTR Return', id: 'cntrReturn', span: 0.5 },
        {
          span: 0.5,
          rows: [
            {
              cols: [
                {
                  title: 'Port of Discharge',
                  id: 'portOfDischarge',
                  span: 0.5
                },
                {
                  title: 'E.T.A',
                  id: 'dischargeEta',
                  span: 0.5
                }
              ]
            },
            {
              cols: [
                {
                  title: 'Place of Delivery',
                  id: 'placeOfDelivery',
                  span: 0.5
                },
                {
                  title: 'E.T.A',
                  id: 'deliveryEta',
                  span: 0.5
                }
              ]
            }
          ]
        }
      ]
    },
    {
      cols: [
        {
          title: 'Commodity',
          id: 'commodity',
          span: 0.5
        },
        { title: 'I.T.NO/CNRU/CPRS#', id: 'itNoCnruCprs#', span: 0.5 }
      ]
    }
  ]
}

export const containerInfoTemplate = {
  rows: [
    {
      cols: [
        { title: 'CONTAINER NO', id: 'containerNo', span: 0.5 },
        { title: 'SIZE', id: 'containerSize', span: 0.5 }
      ]
    },
    {
      cols: [
        {
          title: 'QTY',
          id: 'counts',
          span: 0.5
        },
        { title: 'WEIGHT(kg)', id: 'weight', span: 0.5 }
      ]
    },
    {
      cols: [
        { title: 'MEASURE(cmb)', id: 'measure', span: 0.5 },
        {
          title: 'MARKS & NOS',
          id: 'marks',
          span: 0.5
        }
      ]
    }
  ]
}

export const companyInfo = {
  name: 'Rigel International Inc',
  address:
    '14950 VALLEY VIEW AVENUE LA MIRADA CA 90638, LA MIRADA, CA, CALIFORNIA, UNITED STATES',
  tel: '657-255-4255',
  fax: '909-5510013',
  customerService: 'Irene Zhou',
  email: 'op01@riiexpress.com'
}

export function composeTruckCompanyInfo(companyInfo) {
  const name = companyInfo.name ? companyInfo.name + '\n' : ''
  const address = companyInfo.address ? companyInfo.address + '\n' : ''
  const tel = companyInfo.tel ? 'TEL: ' + companyInfo.tel + '\n' : ''
  const email = companyInfo.email ? 'EMAIL: ' + companyInfo.email + '\n' : ''
  const fax = companyInfo.fax ? 'FAX: ' + companyInfo.fax : ''
  return name + address + tel + email + fax
}

export function composeDirectDeliveryInfo(info) {
  const name = info?.warehouseName + ' ' + info?.factoryNo + '\n'
  const address = info?.address + '\n'
  const tel = 'TEL: ' + info.phone + '\n'
  const email = 'EMAIL: ' + info.email + '\n'
  return name + address + tel + email
}
